<script>
  import { onMount, afterUpdate } from "svelte";
  import { fade } from "svelte/transition";

  import { currentProgress } from "../stores/scrollVars.js";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px

  export let circleSpecs;
  export let isActive;
  // export let scenesWithDetails;
  // export let currentDetails;
  // export let sceneName;

  const r = 40;
  $: linewidth = circleSpecs ? `${(0.5 * r) / parseFloat(circleSpecs.width)}%` : "0.5%";

  const setPathLength = () => {
    let path = document.querySelector(".circlepath");
    if (path && path.getTotalLength() > 0) {
      document.documentElement.style.setProperty("--pathlength", `${path.getTotalLength()}px`);
    }
  };

  onMount(async () => {
    setPathLength();
  });

  afterUpdate(async () => {
    setPathLength();
  });
</script>

<div class="scene-details {$mq.classNames}">
  {#if circleSpecs && isActive}
    <div
      class="circle-detail"
      style="
          left:{circleSpecs.left}; 
          top: {circleSpecs.top};
          right: 2%;
          max-width: {circleSpecs.width};"
      out:fade
    >
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle class="circlepath" cx={r * 1.25} cy={r * 1.25} {r} stroke-width={linewidth} />
        <!--  vector-effect="non-scaling-stroke" -->
      </svg>
    </div>
  {/if}
</div>

<style>
  .circle-detail {
    position: absolute;
    z-index: var(--z-top);
    padding: 15px;
    border-radius: 15px;
  }

  .circlepath {
    stroke: var(--voila-border);
    fill: none;
    animation: move 0.2s linear;
    animation-fill-mode: forwards;
    stroke-dasharray: var(--pathlength) var(--pathlength);
    stroke-dashoffset: var(--pathlength);
    filter: url(#fTexture2);
  }

  @keyframes move {
    100% {
      stroke-dashoffset: 0;
    }
  }
</style>
